import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgIconPlaybackRate11X = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 30, height: 14, viewBox: "0 0 30 14", fill: "none", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.57103 0C6.78911 0 6.9659 0.17679 6.9659 0.394872V13.3897C6.9659 13.6078 6.78911 13.7846 6.57103 13.7846H3.61847C3.40039 13.7846 3.2236 13.6078 3.2236 13.3897V3.50944C3.2236 3.47449 3.19526 3.44615 3.16031 3.44615C3.14887 3.44615 3.13764 3.44926 3.12782 3.45513L0.725028 4.89252C0.461828 5.04997 0.127441 4.86035 0.127441 4.55365V2.29453C0.127441 2.15697 0.19903 2.02933 0.316407 1.9576L3.42495 0.0579349C3.48694 0.0200473 3.55819 0 3.63085 0H6.57103Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M10.2098 14C9.68928 14 9.24281 13.8183 8.87037 13.4548C8.50243 13.0869 8.32069 12.6404 8.32518 12.1154C8.32069 11.6038 8.50243 11.1663 8.87037 10.8029C9.24281 10.4394 9.68928 10.2577 10.2098 10.2577C10.7034 10.2577 11.1386 10.4394 11.5156 10.8029C11.897 11.1663 12.0899 11.6038 12.0944 12.1154C12.0899 12.4654 11.9979 12.784 11.8185 13.0712C11.6435 13.3538 11.4146 13.5804 11.1319 13.751C10.8492 13.917 10.5418 14 10.2098 14Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M17.7249 0C17.943 0 18.1198 0.17679 18.1198 0.394872V13.3897C18.1198 13.6078 17.943 13.7846 17.7249 13.7846H14.7724C14.5543 13.7846 14.3775 13.6078 14.3775 13.3897V3.50944C14.3775 3.47449 14.3492 3.44615 14.3142 3.44615C14.3028 3.44615 14.2915 3.44926 14.2817 3.45513L11.8789 4.89252C11.6157 5.04997 11.2813 4.86035 11.2813 4.55365V2.29453C11.2813 2.15697 11.3529 2.02933 11.4703 1.9576L14.5788 0.0579349C14.6408 0.0200473 14.7121 0 14.7847 0H17.7249Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M22.9826 3.44615C23.1355 3.44615 23.2747 3.53449 23.3399 3.67289L24.3928 5.91047C24.5335 6.20939 24.9572 6.21372 25.1039 5.91774L26.2205 3.66562C26.2872 3.53119 26.4242 3.44615 26.5743 3.44615H29.3578C29.6564 3.44615 29.8469 3.76464 29.7058 4.02769L27.3473 8.42421C27.2834 8.54327 27.2848 8.68671 27.3511 8.80447L29.8214 13.1962C29.9694 13.4594 29.7792 13.7846 29.4772 13.7846H26.7279C26.582 13.7846 26.448 13.7042 26.3794 13.5754L25.0948 11.1644C24.9451 10.8834 24.5415 10.886 24.3955 11.1688L23.1551 13.5709C23.0873 13.7022 22.9519 13.7846 22.8042 13.7846H20.0076C19.7049 13.7846 19.5147 13.458 19.6642 13.1948L22.1568 8.80402C22.2235 8.68654 22.2255 8.54312 22.1622 8.42382L19.826 4.02628C19.6862 3.76328 19.8769 3.44615 20.1747 3.44615H22.9826Z", fill: props.fill }));
});
export default SvgIconPlaybackRate11X;
